import { z } from 'zod';

import { analyticsBasePropertiesSchema } from '../schemas/analytics-base-properties.schema';

export const buildEventSchema = <Shape extends z.ZodRawShape>(shape: Shape) => z.object(shape).merge(analyticsBasePropertiesSchema.partial());
